import { Box, styled, Typography } from '@mui/material';

export const TitleContainer = styled(Box)(({ theme }) => ({
  marginTop: '12px',

  '&:not(:first-of-type)': {
    borderTop: `1px solid ${theme.palette.colors.scrollOnPrimaryBackground}`,
    paddingTop: '24px',
  },

  [theme.breakpoints.up('lg')]: {
    marginTop: 0,

    '&:not(:first-of-type)': {
      marginTop: '12px',
      paddingTop: '32px',
    },
  },
}));

export const TitleStyled = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 700,
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.onPrimaryBackground,
  marginBottom: '16px',
}));
